import { Split } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SplitIcon = createLucideIcon(Split);
